import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {AndroidIcon, IphoneIcon, GameIcon, FlutterIcon, HealthcareIcon, ReactIcon} from "../../../app-constants";
import {Link} from 'gatsby';

const StackItem = [
    {
        icon: AndroidIcon,
        title: 'Android app development',
        description: (
            <>
                TekRevol offers the best,{' '}
                <Link to="/android-app-development" rel="noopener" aria-label="TekRevol">
                android app development services
                </Link> {' '}
                in California – building applications with a feature-rich interface. We’ve served a lot of industries with our cutting-edge app solutions. Our professional app developers in California utilize their expertise to indulge the latest functionalities that can improve your business to the fullest.</>
        ),
    },
    {
        icon: IphoneIcon,
        title: 'Iphone app development',
        description: (
            <>
                Considering the specific requirements and complex procedures of iPhone apps, we have the best facilities to develop a powerful mobile app. You can share your goal and we will craft the idea into a real implementation with our{' '}
                <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
                    iPhone app development services
                </Link> {' '}
                .Therefore, we can provide a tailor-made app with a remarkable UI to our clients based on the latest technology.</>
        ),
    },
    {
        icon: GameIcon,
        title: 'Game app development',
        description: (
            <>
                We have been serving our clients as a top-tier{' '}
                <Link to="/game-development" rel="noopener" aria-label="TekRevol">
                    game app development company
                </Link>
                .since inception. You can count on us to develop robust gaming apps for both Android and iOS. We utilize stunning tools and engines like Unity, Unreal Engine, and Lumberyards to ensure flawless game development. Moreover, we have already deployed HTML5 frameworks such as ImpactJS, Phaser, Turbulenz, etc, to develop complex games.
            </>
        ),
    },
    {
        icon: FlutterIcon,
        title: 'Flutter app development',
        description: (
            <>
                Scale up your business with our top-class{' '}
                <Link to="/flutter-app-development" rel="noopener" aria-label="TekRevol">
                    Flutter development services
                </Link> {' '}
                , the latest and most reliable technology in cross-platform app development .We possess the finest expertise in this stack by providing multiple solutions to our clientele. However, the great thing about using Flutter is that we can develop both Android and iOS apps using the same code base. That's how you can target a wider audience with these cross-platform solutions.
            </>
        ),
    },
    {
        icon: HealthcareIcon,
        title: 'Healthcare app development',
        description: (
            <>
                As a{' '}
                <Link to="/healthcare-app-development" rel="noopener" aria-label="TekRevol">
                    healthcare app development company
                </Link> {' '}
                , we not only improvise the process but also save your time and cost. You can enhance your healthcare operations using our innovative solutions like Electronic Health Records (EHR), Health Information Exchange (HIE), Telehealth, and more.
            </>
        ),
    },
    {
        icon: ReactIcon,
        title: 'React Native app development',
        description: 'TekRevol harnesses the capabilities of React Native to create resilient mobile apps compatible with both Android and iOS platforms, guaranteeing extensive features and flawless execution. Our proficient team actively develops applications that not only fulfill your individual needs but also deliver a consistently top-notch user experience across a wide range of devices and operating systems.',
    },

];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2> Business Empowering Mobile App Development Services in California</h2>
                        <p className="impro_para">We transcend the role of a mere mobile app development company in California – we emerge as your innovation partner. TekRevol takes the lead in pioneering iOS and Android app development in California, where the dynamic intersection of cutting-edge technology and innovative solutions is at its peak. </p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;